/* ==========================================================================
   Theme JS — no dependencies
   ========================================================================== */

(function () {
  'use strict';

  var ROUTES = window.themeRoutes || {};
  var MONEY_FORMAT = window.themeMoneyFormat || '${{amount}}';

  /* ------------------------------------------------------------- helpers */

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function on(el, evt, fn) {
    if (el) el.addEventListener(evt, fn);
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = parts[0];

    return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount':
        case 'amount_with_comma_separator':
          return name === 'amount_with_comma_separator'
            ? withDecimals.replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1')
            : withDecimals;
        case 'amount_no_decimals':
          return noDecimals;
        case 'amount_no_decimals_with_comma_separator':
          return noDecimals.replace(/,/g, '.');
        default:
          return withDecimals;
      }
    });
  }

  function publish(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  /* ------------------------------------------------- body scroll locking */

  var lockCount = 0;

  function lockScroll() {
    lockCount += 1;
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) document.body.style.overflow = '';
  }

  /* --------------------------------------------------------- overlay util */

  function getOverlay() {
    var overlay = $('[data-overlay]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'overlay';
      overlay.setAttribute('data-overlay', '');
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  /* =======================================================================
     Mobile navigation
     ======================================================================= */

  function initMobileNav() {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;

    var overlay = getOverlay();

    function open() {
      nav.classList.add('is-open');
      overlay.classList.add('is-open');
      lockScroll();
    }

    function close() {
      nav.classList.remove('is-open');
      overlay.classList.remove('is-open');
      unlockScroll();
    }

    $$('[data-mobile-nav-open]').forEach(function (btn) {
      on(btn, 'click', open);
    });

    $$('[data-mobile-nav-close]').forEach(function (btn) {
      on(btn, 'click', close);
    });

    on(overlay, 'click', close);

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* =======================================================================
     Accordions
     ======================================================================= */

  function initAccordions() {
    $$('[data-accordion]').forEach(function (group) {
      var single = group.hasAttribute('data-accordion-single');
      var toggles = $$('[data-accordion-toggle]', group);

      toggles.forEach(function (toggle) {
        var panel = toggle.nextElementSibling;
        if (!panel) return;

        if (toggle.getAttribute('aria-expanded') === 'true') {
          panel.style.height = 'auto';
        }

        on(toggle, 'click', function () {
          var isOpen = toggle.getAttribute('aria-expanded') === 'true';

          if (single && !isOpen) {
            toggles.forEach(function (other) {
              if (other === toggle) return;
              other.setAttribute('aria-expanded', 'false');
              var otherPanel = other.nextElementSibling;
              if (otherPanel) {
                otherPanel.style.height = otherPanel.scrollHeight + 'px';
                requestAnimationFrame(function () {
                  otherPanel.style.height = '0px';
                });
              }
            });
          }

          toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

          if (isOpen) {
            panel.style.height = panel.scrollHeight + 'px';
            requestAnimationFrame(function () {
              panel.style.height = '0px';
            });
          } else {
            panel.style.height = panel.scrollHeight + 'px';
            window.setTimeout(function () {
              if (toggle.getAttribute('aria-expanded') === 'true') {
                panel.style.height = 'auto';
              }
            }, 320);
          }
        });
      });
    });
  }

  /* =======================================================================
     Product media gallery
     ======================================================================= */

  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var slidesWrap = $('[data-gallery-slides]', gallery);
      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      if (!slidesWrap || !slides.length) return;

      function goTo(index) {
        var target = slides[index];
        if (!target) return;
        // Assign scrollLeft rather than scrollTo({behavior:'smooth'}): the strip
        // uses scroll-snap-type: x mandatory, which cancels a smooth programmatic
        // scroll and snaps back to the first slide before it can travel.
        slidesWrap.scrollLeft = target.offsetLeft - slides[0].offsetLeft;
      }

      function setActive(index) {
        thumbs.forEach(function (thumb, i) {
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb, i) {
        on(thumb, 'click', function () {
          goTo(i);
          setActive(i);
        });
      });

      on($('[data-gallery-prev]', gallery), 'click', function () {
        var current = currentIndex();
        goTo(Math.max(0, current - 1));
      });

      on($('[data-gallery-next]', gallery), 'click', function () {
        var current = currentIndex();
        goTo(Math.min(slides.length - 1, current + 1));
      });

      function currentIndex() {
        var scroll = slidesWrap.scrollLeft;
        var width = slidesWrap.clientWidth || 1;
        return Math.round(scroll / width);
      }

      var ticking = false;
      on(slidesWrap, 'scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          setActive(currentIndex());
          ticking = false;
        });
      });

      setActive(0);

      // jump to a variant image when the variant changes
      document.addEventListener('variant:change', function (e) {
        var mediaId = e.detail && e.detail.variant && e.detail.variant.featured_media_id;
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i += 1) {
          if (String(slides[i].dataset.mediaId) === String(mediaId)) {
            goTo(i);
            setActive(i);
            break;
          }
        }
      });
    });
  }

  /* =======================================================================
     Bundle / quantity-break selector
     ======================================================================= */

  function initBundles() {
    $$('[data-bundles]').forEach(function (root) {
      var cards = $$('[data-bundle]', root);
      if (!cards.length) return;

      function select(card) {
        cards.forEach(function (other) {
          other.classList.toggle('is-selected', other === card);
          var input = $('[data-bundle-input]', other);
          if (input) input.checked = other === card;
        });
        update();
      }

      function selected() {
        return cards.filter(function (card) {
          return card.classList.contains('is-selected');
        })[0] || cards[0];
      }

      function addonTotal(card) {
        return $$('[data-addon-input]', card).reduce(function (sum, input) {
          return input.checked ? sum + (parseInt(input.dataset.price, 10) || 0) : sum;
        }, 0);
      }

      function update() {
        var card = selected();
        if (!card) return;

        var base = parseInt(card.dataset.price, 10) || 0;
        var compare = parseInt(card.dataset.compare, 10) || 0;
        var total = base + addonTotal(card);
        var compareTotal = (compare || base) + addonTotal(card);

        var totalEl = $('[data-bundle-total]', root.closest('[data-product-root]') || document);
        if (totalEl) totalEl.textContent = formatMoney(total);

        var saveEl = $('[data-bundle-save]', root.closest('[data-product-root]') || document);
        if (saveEl) {
          var saved = compareTotal - total;
          if (saved > 0) {
            saveEl.textContent = saveEl.dataset.template
              ? saveEl.dataset.template.replace('[amount]', formatMoney(saved))
              : 'You save ' + formatMoney(saved);
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }

        publish('bundle:change', {
          quantity: parseInt(card.dataset.quantity, 10) || 1,
          variantId: card.dataset.variantId,
          total: total,
          compare: compareTotal,
          discount: compareTotal > total ? Math.round(((compareTotal - total) / compareTotal) * 100) : 0
        });
      }

      cards.forEach(function (card) {
        on($('[data-bundle-input]', card), 'change', function () {
          select(card);
        });

        on(card, 'click', function (e) {
          if (e.target.closest('[data-addon]')) return;
          select(card);
        });

        $$('[data-addon-input]', card).forEach(function (input) {
          on(input, 'change', function (e) {
            e.stopPropagation();
            update();
          });
        });
      });

      var preselected = cards.filter(function (card) {
        return card.hasAttribute('data-bundle-default');
      })[0];

      select(preselected || cards[0]);
    });
  }

  /* =======================================================================
     Quantity inputs
     ======================================================================= */

  function initQuantity(root) {
    $$('[data-quantity]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;

      // the cart drawer is re-rendered on every change, so this runs again on
      // fresh nodes; the flag keeps already-bound controls from doubling up
      if (wrap.dataset.quantityBound) return;
      wrap.dataset.quantityBound = 'true';

      $$('[data-quantity-change]', wrap).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = parseInt(btn.dataset.quantityChange, 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* =======================================================================
     Variant picker
     ======================================================================= */

  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var dataEl = $('[data-variant-json]', picker);
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      var form = picker.closest('form');
      var idInput = form ? $('[name="id"]', form) : null;

      function currentOptions() {
        var values = [];
        $$('[data-option-index]', picker).forEach(function (el) {
          if (el.type === 'radio') {
            if (el.checked) values[parseInt(el.dataset.optionIndex, 10)] = el.value;
          } else {
            values[parseInt(el.dataset.optionIndex, 10)] = el.value;
          }
        });
        return values;
      }

      function match() {
        var options = currentOptions();
        return variants.filter(function (variant) {
          return variant.options.every(function (opt, i) {
            return opt === options[i];
          });
        })[0];
      }

      function apply() {
        var variant = match();
        if (!variant) return;

        if (idInput) idInput.value = variant.id;

        var priceEl = $('[data-variant-price]', picker.closest('[data-product-root]') || document);
        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        var compareEl = $('[data-variant-compare]', picker.closest('[data-product-root]') || document);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        var button = form ? $('[data-add-to-cart]', form) : null;
        if (button) {
          button.disabled = !variant.available;
          var label = $('[data-add-to-cart-text]', button) || button;
          label.textContent = variant.available
            ? button.dataset.labelAvailable || 'Add to cart'
            : button.dataset.labelSoldOut || 'Sold out';
        }

        publish('variant:change', { variant: variant });
      }

      $$('[data-option-index]', picker).forEach(function (el) {
        on(el, 'change', apply);
      });

      apply();
    });
  }

  /* =======================================================================
     Cart
     ======================================================================= */

  var DRAWER_SECTION = 'cart-drawer';

  function applyDrawerHtml(html) {
    if (!html) return false;

    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer]', parsed);
    var current = $('[data-cart-drawer]');
    if (!fresh || !current) return false;

    var wasOpen = current.classList.contains('is-open');
    current.innerHTML = fresh.innerHTML;
    if (wasOpen) current.classList.add('is-open');
    bindCartDrawer();
    return true;
  }

  var Cart = {
    open: function () {
      var drawer = $('[data-cart-drawer]');
      if (!drawer) return;
      drawer.classList.add('is-open');
      getOverlay().classList.add('is-open');
      lockScroll();
    },

    close: function () {
      var drawer = $('[data-cart-drawer]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      getOverlay().classList.remove('is-open');
      unlockScroll();
    },

    add: function (items) {
      return fetch((ROUTES.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        // asking for the section here returns the redrawn drawer with the same
        // round trip, so the panel can never open before the cart has caught up
        body: JSON.stringify({ items: items, sections: DRAWER_SECTION })
      }).then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'Cart error');
          return body;
        });
      });
    },

    change: function (line, quantity) {
      return fetch((ROUTES.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: DRAWER_SECTION })
      }).then(function (res) {
        return res.json();
      });
    },

    refresh: function (payload) {
      var rendered = payload && payload.sections && payload.sections[DRAWER_SECTION];
      var step;

      if (rendered && applyDrawerHtml(rendered)) {
        step = Promise.resolve();
      } else {
        // Note: no Accept header. Sending "application/json" to a product or cart
        // URL makes Shopify answer with that resource's own JSON and silently
        // ignore ?sections=, which leaves the drawer showing a stale empty cart.
        step = fetch((ROUTES.root || '/') + '?sections=' + DRAWER_SECTION)
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            applyDrawerHtml(data[DRAWER_SECTION]);
          })
          .catch(function () {
            /* the count below still updates */
          });
      }

      return step.then(function () {
        return fetch((ROUTES.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            $$('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.hidden = cart.item_count === 0;
            });
            publish('cart:updated', { cart: cart });
          });
      });
    }
  };

  window.themeCart = Cart;

  function bindCartDrawer() {
    // the +/- controls live inside the replaced markup and need binding again
    initQuantity($('[data-cart-drawer]'));

    $$('[data-cart-close]').forEach(function (btn) {
      on(btn, 'click', Cart.close);
    });

    $$('[data-cart-remove]').forEach(function (btn) {
      on(btn, 'click', function () {
        var line = parseInt(btn.dataset.cartRemove, 10);
        btn.disabled = true;
        Cart.change(line, 0).then(function (res) {
          Cart.refresh(res);
        });
      });
    });

    $$('[data-cart-line-qty]').forEach(function (input) {
      on(input, 'change', function () {
        var line = parseInt(input.dataset.cartLineQty, 10);
        Cart.change(line, parseInt(input.value, 10) || 0).then(function (res) {
          Cart.refresh(res);
        });
      });
    });
  }

  function initCart() {
    var overlay = getOverlay();
    on(overlay, 'click', Cart.close);

    $$('[data-cart-open]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        if (!$('[data-cart-drawer]')) return;
        e.preventDefault();
        Cart.open();
      });
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') Cart.close();
    });

    bindCartDrawer();
  }

  /* =======================================================================
     Product form submit (bundle aware)
     ======================================================================= */

  function initProductForms() {
    $$('[data-product-form]').forEach(function (form) {
      var button = $('[data-add-to-cart]', form);
      var errorEl = $('[data-form-error]', form);

      on(form, 'submit', function (e) {
        e.preventDefault();

        var root = form.closest('[data-product-root]') || document;
        var card = $('[data-bundle].is-selected', root);
        var idInput = $('[name="id"]', form);
        var mainId = (card && card.dataset.variantId) || (idInput && idInput.value);
        if (!mainId) return;

        var quantity = card
          ? parseInt(card.dataset.quantity, 10) || 1
          : parseInt((($('[data-quantity] input', form) || {}).value) || 1, 10);

        var properties = {};
        var items = [];

        if (card) {
          $$('[data-addon-input]', card).forEach(function (input) {
            if (!input.checked) return;
            if (input.dataset.variantId) {
              items.push({ id: Number(input.dataset.variantId), quantity: 1 });
            } else {
              properties[input.dataset.label] = input.dataset.value || 'Yes';
            }
          });
          if (card.dataset.label) properties['Pack'] = card.dataset.label;
        }

        var mainItem = { id: Number(mainId), quantity: quantity };
        if (Object.keys(properties).length) mainItem.properties = properties;
        items.unshift(mainItem);

        if (button) {
          button.disabled = true;
          button.dataset.loading = 'true';
        }
        if (errorEl) errorEl.hidden = true;

        Cart.add(items)
          .then(function (res) {
            return Cart.refresh(res);
          })
          .then(function () {
            Cart.open();
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.hidden = false;
            }
          })
          .then(function () {
            if (button) {
              button.disabled = false;
              delete button.dataset.loading;
            }
          });
      });
    });
  }

  /* =======================================================================
     Sticky add to cart
     ======================================================================= */

  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    if (!bar) return;

    var anchor = $('[data-sticky-anchor]') || $('[data-product-form]');
    if (!anchor) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { rootMargin: '0px 0px -100% 0px' }
    );

    observer.observe(anchor);

    on($('[data-sticky-submit]', bar), 'click', function () {
      var form = $('[data-product-form]');
      if (!form) return;
      var top = form.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    // the bar carries three figures; all of them have to follow the chosen pack
    document.addEventListener('bundle:change', function (e) {
      var detail = e.detail || {};
      var priceEl = $('[data-sticky-price]', bar);
      var compareEl = $('[data-sticky-compare]', bar);
      var badgeEl = $('[data-sticky-badge]', bar);

      if (priceEl && typeof detail.total === 'number') {
        priceEl.textContent = formatMoney(detail.total);
      }

      if (compareEl) {
        var showCompare = typeof detail.compare === 'number' && detail.compare > detail.total;
        if (showCompare) compareEl.textContent = formatMoney(detail.compare);
        compareEl.hidden = !showCompare;
      }

      if (badgeEl) {
        if (detail.discount > 0) {
          badgeEl.textContent = badgeEl.dataset.template
            ? badgeEl.dataset.template.replace('[percent]', detail.discount)
            : 'Save ' + detail.discount + '%';
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }
    });
  }

  /* =======================================================================
     Video cards — play/pause and sound, without the native control bar
     ======================================================================= */

  function initVideoCards() {
    $$('[data-video]').forEach(function (wrap) {
      var video = $('[data-video-el]', wrap);
      if (!video) return;

      var toggle = $('[data-video-toggle]', wrap);
      var sound = $('[data-video-sound]', wrap);

      function sync() {
        wrap.classList.toggle('is-playing', !video.paused);
        wrap.classList.toggle('is-unmuted', !video.muted);
        if (toggle) {
          toggle.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        }
        if (sound) {
          sound.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
        }
      }

      on(toggle, 'click', function () {
        if (video.paused) {
          var played = video.play();
          if (played && played.catch) played.catch(function () {});
        } else {
          video.pause();
        }
      });

      on(sound, 'click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        // a muted autoplaying clip is often already running; unmuting should not restart it
        if (!video.muted && video.paused) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
        sync();
      });

      ['play', 'pause', 'volumechange', 'loadeddata'].forEach(function (evt) {
        on(video, evt, sync);
      });

      // pause clips once they scroll out of view so several cannot fight for bandwidth
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) return;
              if (!video.paused && video.muted) video.pause();
            });
          },
          { threshold: 0.15 }
        );
        observer.observe(wrap);
      }

      sync();
    });
  }

  /* =======================================================================
     Countdown timers
     ======================================================================= */

  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var minutes = parseInt(el.dataset.countdown, 10) || 15;
      var storageKey = 'theme-countdown-' + (el.dataset.countdownKey || 'default');
      var deadline;

      try {
        deadline = parseInt(window.sessionStorage.getItem(storageKey), 10);
      } catch (err) {
        deadline = NaN;
      }

      if (!deadline || deadline < Date.now()) {
        deadline = Date.now() + minutes * 60 * 1000;
        try {
          window.sessionStorage.setItem(storageKey, String(deadline));
        } catch (err) {
          /* private mode */
        }
      }

      var daysEl = $('[data-countdown-days]', el);
      var hoursEl = $('[data-countdown-hours]', el);
      var minsEl = $('[data-countdown-minutes]', el);
      var secsEl = $('[data-countdown-seconds]', el);

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        var remaining = Math.max(0, deadline - Date.now());
        var totalSeconds = Math.floor(remaining / 1000);

        // with a days box the hours roll over daily, without it they keep counting up
        if (daysEl) {
          daysEl.textContent = pad(Math.floor(totalSeconds / 86400));
          if (hoursEl) hoursEl.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
        } else if (hoursEl) {
          hoursEl.textContent = pad(Math.floor(totalSeconds / 3600));
        }

        if (minsEl) minsEl.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        if (secsEl) secsEl.textContent = pad(totalSeconds % 60);

        if (remaining <= 0) {
          deadline = Date.now() + minutes * 60 * 1000;
          try {
            window.sessionStorage.setItem(storageKey, String(deadline));
          } catch (err) {
            /* ignore */
          }
        }
      }

      tick();
      window.setInterval(tick, 1000);
    });
  }

  /* =======================================================================
     Scroll to top
     ======================================================================= */

  function initScrollTop() {
    var btn = $('[data-to-top]');
    if (!btn) return;

    on(btn, 'click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    function toggle() {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }

    on(window, 'scroll', toggle);
    toggle();
  }

  /* =======================================================================
     Reveal on scroll
     ======================================================================= */

  function initReveal() {
    var items = $$('.reveal');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  /* =======================================================================
     Boot
     ======================================================================= */

  function boot() {
    initMobileNav();
    initAccordions();
    initGallery();
    initBundles();
    initQuantity();
    initVariantPickers();
    initCart();
    initProductForms();
    initStickyAtc();
    initVideoCards();
    initCountdowns();
    initScrollTop();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // re-run on Shopify theme editor section reloads
  document.addEventListener('shopify:section:load', boot);
})();
